import { SideMenu } from "../models/proj.model";

export const SIDE_MENU_CONSTANTS: SideMenu = {
    MENU_ITEMS: [
        {
            section: '',
            items: [
                {
                    label: 'Home',
                    icon: 'ti ti-home',
                    route: '/home',
                    disabled: true
                },
            ]
        },
        {
            section: 'MANAGE',
            items: [
                {
                    label: 'Digital Library',
                    icon: 'ti ti-server',
                    route: '/digital-library',
                    disabled: false
                },
                {
                    label: 'Workspace',
                    icon: 'ti ti-stack-2',
                    route: '/workspace',
                    disabled: true
                },
            ]
        },
        {
            section: 'REVIEW',
            items: [
                {
                    label: 'Approvals',
                    icon: 'ti ti-circle-check',
                    route: '/approvals',
                    badge: 7,
                    disabled: true
                }
            ]
        },
        {
            section: 'USER MANAGEMENT',
            items: [
                {
                    label: 'Organizations',
                    icon: 'building',
                    route: 'usermgmt/customer',
                    resourceName: 'User Management',
                    resourceTypeName: 'Application',
                    disabled: false
                },
                {
                    label: 'Applications',
                    icon: 'layout-2',
                    route: 'usermgmt/applications',
                    resourceName: 'User Management',
                    resourceTypeName: 'Application',
                    disabled: false
                },
                {
                    label: 'Roles',
                    icon: 'key',
                    route: 'usermgmt/roles',
                    resourceName: 'User Management',
                    resourceTypeName: 'Application',
                    disabled: false
                },
                {
                    label: 'Users',
                    icon: 'users',
                    route: 'usermgmt/users',
                    resourceName: 'User Management',
                    resourceTypeName: 'Application',
                    disabled: false
                },
            ]
        },

    ]
}


